import axios from 'axios';
import { isUndefined } from 'lodash';
import LinkCollection from '@/models/LinkCollection';

const config = {
  fetch: () => axios.get(process.env.CONFIG_URL).then((res) => {
    const data = config.transformFromFirebase(res.data);
    return data;
  }),
  transformFromFirebase(data) {
    return {
      global: {
        nav: config.transformGlobalFromFirebase(data.globalContent),
      },
      local: {
        nav: config.transformLocalFromFirebase(data.localContent),
      },
      metaData: data.metaData,
    };
  },
  hasCameraPos(datum) {
    return !isUndefined(datum.cameraPos) &&
      !isUndefined(datum.cameraPos.lat) &&
      !isUndefined(datum.cameraPos.lon);
  },
  transformGlobalFromFirebase(global) {
    const data = Object.keys(global).map((key) => {
      const datum = global[key];
      const item = {
        id: key,
        title: datum.title,
        subTitle: datum.subtitle,
        lat: datum.lat,
        lon: datum.lon,
        timezone: datum.timezone,
        flightTime: datum.flightTime,
        cameraPos: this.hasCameraPos(datum) ? datum.cameraPos : null,
      };
      return item;
    });
    return data;
  },
  transformLocalFromFirebase(local) {
    const data = Object.keys(local).map((key) => {
      const datum = local[key];
      const children = Object
        .entries(datum.children)
        .map(([childKey, value]) => ({ id: childKey, ...value }));
      const overview = children.find(({ title }) => title === 'Overview');
      const item = {
        id: key,
        title: datum.title,
        sortOrder: datum.sortOrder,
        navigateTo: datum.navigateTo,
        colour: datum.colour,
        boundaryCoordinates: datum.boundaryCoordinates ?
          JSON.parse(datum.boundaryCoordinates) :
          null,
        view: datum.view,
        children: config.processChildren(datum.children),
        overview: overview ? overview.id : null,
      };
      return item;
    });
    return data;
  },
  processChildren(children) {
    const data = Object.keys(children).map((key) => {
      const datum = children[key];
      const item = {
        id: key,
        title: datum.title,
        view: datum.view,
        lat: datum.lat,
        lon: datum.lon,
        path: datum.type === 'route' ? {
          routeDashGap: datum.routeDashGap,
          routeDashWidth: datum.routeDashWidth,
          routeLineWidth: datum.routeLineWidth,
          routeColour: datum.routeColour,
          routeDashed: datum.routeDashed,
          originMarkerPosition: datum.routeOriginMarkerPosition,
          destinationMarkerPosition: datum.routeDestinationMarkerPosition,
          routeOriginLat: datum.routeOriginLat,
          routeOriginLon: datum.routeOriginLon,
          routeDestinationLat: datum.routeDestinationLat,
          routeDestinationLon: datum.routeDestinationLon,
          route: datum.route ? JSON.parse(datum.route) : null,
          routeText: datum.routeText,
        } : null,
        details: {
          text: datum.body,
          video: datum.video,
          images: [
            datum.image0,
            datum.image1,
            datum.image2,
          ],
          showPopup: datum.showPopup,
        },
        markerPosition: datum.markerPosition,
        type: datum.type,
        markerClass: datum.markerClass,
        children: datum.children ? config.processChildren(datum.children) : null,
        sortOrder: datum.sortOrder,
        navigateTo: datum.navigateTo,
        includeChildrenInNav: datum.includeChildrenInNav,
      };
      return item;
    });
    return data;
  },
  get: () => config.fetch().then(config.mapModels),
  mapModels: (data) => {
    const models = {
      global: {
        nav: new LinkCollection(data.global.nav),
      },
      local: {
        nav: new LinkCollection(data.local.nav),
      },
      metaData: data.metaData,
    };
    return models;
  },
  process: (data) => {
    if (!data) {
      return config.fetch();
    }
    return data;
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/services/Config.js